import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
}

export function Card({ className, interactive, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        "bg-surface border border-border rounded-xl",
        "shadow-[var(--shadow-card)]",
        interactive &&
          "transition-shadow transition-transform duration-200 hover:shadow-[var(--shadow-lift)] hover:-translate-y-0.5",
        className,
      )}
      {...rest}
    />
  );
}

export function CardBody({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-6", className)} {...rest} />;
}
